/*=========================================================================================
  File Name: moduleEcommerceActions.js
  Description: Ecommerce Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  toggleHouseForSaleInWishList ({ commit }, item) {
    commit('TOGGLE_ITEM_IN_WISH_LIST_HOUSE_FOR_SALE', item)
  },
  toggleRentalHouseInWishList ({ commit }, item) {
    commit('TOGGLE_ITEM_IN_WISH_LIST_RENTAL_HOUSE', item)
  },
  toggleItemInCart ({ dispatch }, item) {
    dispatch('addItemInCart', item)
  },
  addItemInCart ({ commit }, item) {
    
    // Below properties should be added as per requirement from back-end
    // This is added just for demo purpose
    commit('ADD_ITEM_IN_CART', item)
  },
  updateItemQuantity ({ commit }, payload) {
    commit('UPDATE_ITEM_QUANTITY', payload)
  }
}
